// extracted by mini-css-extract-plugin
export var deleteModalBody = "styles-module__deleteModalBody___ku_zS";